import { HandMetal } from 'lucide-react';

/**
 * PassProvenanceBadge — tiny attribution tag showing which GroovLenser
 * passed a card to the current user. Rendered on cards inside track
 * detail modals + optionally on compact cards. Only shown when the pass
 * was signed (users can opt out at send time).
 *
 * Props:
 *   passedFrom — { from_username, mode, at }
 *   compact    — shrink to icon-only chip for tight layouts
 */
export default function PassProvenanceBadge({ passedFrom, compact = false }) {
  if (!passedFrom || !passedFrom.from_username) return null;
  const mode = passedFrom.mode || 'copy';
  const modeLabel =
    mode === 'trade' ? 'Traded with' : mode === 'crate' ? 'From crate by' : 'Passed by';

  if (compact) {
    return (
      <span
        className="inline-flex items-center gap-1 rounded-full bg-[hsl(var(--primary))]/12 text-[hsl(var(--primary))] px-1.5 py-0.5 text-[9px] font-mono uppercase tracking-widest"
        title={`${modeLabel} @${passedFrom.from_username}`}
        data-testid="pass-provenance-badge"
      >
        <HandMetal className="w-2.5 h-2.5" />@{passedFrom.from_username}
      </span>
    );
  }

  return (
    <div
      className="inline-flex items-center gap-1.5 rounded-full bg-[hsl(var(--primary))]/12 border border-[hsl(var(--primary))]/30 text-[hsl(var(--primary))] px-2 py-0.5 text-[10px] font-medium"
      title={passedFrom.at ? new Date(passedFrom.at).toLocaleDateString() : ''}
      data-testid="pass-provenance-badge"
    >
      <HandMetal className="w-3 h-3" />
      <span>
        {modeLabel} <span className="font-mono">@{passedFrom.from_username}</span>
      </span>
    </div>
  );
}
